var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper--default p-2 m-1"},[_c('h2',{staticClass:"text-center"},[_vm._v("Verkoop orders - "+_vm._s(_vm.franchise))]),_c('hr'),(_vm.loading)?_c('Loading'):_c('SalesOrderTable',{attrs:{"table_data":_vm.franchise_data,"table_data_total":_vm.franchise_data_sum,"table_style":"210","franchise":"True"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }